import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/27_clouds/27_clouds"
 * Contains 1 texture(s)
 */
export class Tablet27CloudsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/27_clouds/27_clouds';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '27_clouds.jpg'
    ] as const;
}
